(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
    typeof define === 'function' && define.amd ? define(['react'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = factory(global.React)));
})(this, (function (React) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

    var _assign = function __assign() {
      _assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return _assign.apply(this, arguments);
    };

    var classnames = {exports: {}};

    /*!
    	Copyright (c) 2018 Jed Watson.
    	Licensed under the MIT License (MIT), see
    	http://jedwatson.github.io/classnames
    */

    (function (module) {
    /* global define */

    (function () {

    	var hasOwn = {}.hasOwnProperty;

    	function classNames() {
    		var classes = [];

    		for (var i = 0; i < arguments.length; i++) {
    			var arg = arguments[i];
    			if (!arg) continue;

    			var argType = typeof arg;

    			if (argType === 'string' || argType === 'number') {
    				classes.push(arg);
    			} else if (Array.isArray(arg)) {
    				if (arg.length) {
    					var inner = classNames.apply(null, arg);
    					if (inner) {
    						classes.push(inner);
    					}
    				}
    			} else if (argType === 'object') {
    				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
    					classes.push(arg.toString());
    					continue;
    				}

    				for (var key in arg) {
    					if (hasOwn.call(arg, key) && arg[key]) {
    						classes.push(key);
    					}
    				}
    			}
    		}

    		return classes.join(' ');
    	}

    	if (module.exports) {
    		classNames.default = classNames;
    		module.exports = classNames;
    	} else {
    		window.classNames = classNames;
    	}
    }());
    }(classnames));

    var classNames = classnames.exports;

    function styleInject(css, ref) {
      if (ref === void 0) ref = {};
      var insertAt = ref.insertAt;
      if (!css || typeof document === 'undefined') {
        return;
      }
      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';
      if (insertAt === 'top') {
        if (head.firstChild) {
          head.insertBefore(style, head.firstChild);
        } else {
          head.appendChild(style);
        }
      } else {
        head.appendChild(style);
      }
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.responsive_link {\n  display: flex;\n  gap: 0.5rem;\n  cursor: pointer;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n  justify-items: flex-end;\n  text-decoration: none;\n  font-family: \"AvenirLTStd-65-Medium\";\n}\n.responsive_link > .link_text {\n  display: flex;\n  align-items: center;\n  color: #007191;\n  font-weight: 550;\n  font-size: 0.875rem;\n  cursor: pointer;\n  line-height: 1.43;\n}\n.responsive_link > .link_children_wrapper {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n}\n.responsive_link.disabled {\n  pointer-events: none;\n}\n.responsive_link.disabled > .link_text {\n  color: #707272;\n}\n.responsive_link.disabled > .link_children_wrapper > svg > path {\n  fill: #707272;\n}\n.responsive_link:active[aria-disabled=false] {\n  background-color: #c8e6f1;\n  text-decoration-color: #004c60;\n}\n.responsive_link:focus[aria-disabled=false] {\n  outline: 2px solid #004c60;\n  border-radius: 5px;\n}\n.responsive_link:hover[aria-disabled=false] {\n  text-decoration: underline;\n  text-decoration-color: #004c60;\n}\n.responsive_link:active[aria-disabled=true] {\n  background-color: transparent;\n}\n.responsive_link:focus[aria-disabled=true] {\n  box-shadow: none;\n  border-radius: 0;\n}\n.responsive_link:hover[aria-disabled=true] {\n  text-decoration: none;\n}";
    styleInject(css_248z);

    var ResponsiveLink = function (_a) {
        var linkText = _a.linkText, link = _a.link, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, children = _a.children, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'right' : _c, _d = _a.textStyle, textStyle = _d === void 0 ? {} : _d, _e = _a.linkAnchorAttributes, linkAnchorAttributes = _e === void 0 ? {} : _e;
        var anchorAttributes = {};
        if (!isDisabled) {
            switch (typeof link) {
                case 'string':
                    anchorAttributes = _assign(_assign({}, linkAnchorAttributes), { href: link });
                    break;
                case 'function':
                    anchorAttributes = _assign(_assign({}, linkAnchorAttributes), { onClick: link, onKeyDown: function (event) {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                link();
                            }
                        } });
                    break;
            }
        }
        // Not using row-reverse
        var childrenNode = children && (React__default["default"].createElement("div", { className: 'link_children_wrapper', "data-testid": 'link_children_wrapper' }, children));
        return (React__default["default"].createElement("a", _assign({ className: classNames({
                responsive_link: true,
                disabled: isDisabled,
            }), tabIndex: isDisabled ? -1 : 0, "aria-label": linkText, "aria-disabled": isDisabled, "data-testid": 'link' }, anchorAttributes),
            iconPosition === 'left' && childrenNode,
            React__default["default"].createElement("p", { className: classNames({ link_text: true, disabled: isDisabled }), style: textStyle }, linkText),
            iconPosition === 'right' && childrenNode));
    };

    return ResponsiveLink;

}));
